export const CLASS_NAME = 'cst-chart-page-controls'
